import styles from "./LSingleColumn.module.css";

/**
 * LSingleColumn — page layout z jedną kolumną `main` plus opcjonalny hero
 * split nad nią: 1 duży obszar po lewej + 2 małe po prawej w pionie.
 *
 * Słot `main` przyjmuje React.ReactNode (zwykle `<WindowArea name="main" />`
 * dla homepage; w Fazie F.1+ catalog page wstawi `<CatalogContentArea />`).
 *
 * **Hero strefy** (`heroLarge` / `heroSmallTop` / `heroSmallBottom`) są
 * opcjonalne — gdy props nie podane, sekcja nie jest renderowana w ogóle.
 * Gdy są podane ale puste (brak okien w danej strefie), CSS `:has(article)`
 * gate ukrywa cały kontener hero — statyczne strony bez hero wyglądają
 * identycznie jak przed dodaniem split'u.
 *
 * Convention: page layouts (folder `pages/`) NIE mają dedykowanego catalog
 * area — są dla homepage / static pages. Catalog layouts (folder `catalogs/`,
 * Faza F.1) dziedziczą strukturę ale `main` slot to catalog content.
 */
export function LSingleColumn({
  main,
  heroLarge,
  heroSmallTop,
  heroSmallBottom,
}: LSingleColumnProps) {
  const hasHero =
    heroLarge !== undefined ||
    heroSmallTop !== undefined ||
    heroSmallBottom !== undefined;

  return (
    <div className={styles.root}>
      {hasHero && (
        <div className={styles.hero}>
          <div className={styles.heroLarge}>{heroLarge}</div>
          <div className={styles.heroSmallTop}>{heroSmallTop}</div>
          <div className={styles.heroSmallBottom}>{heroSmallBottom}</div>
        </div>
      )}
      <div className={styles.main}>{main}</div>
    </div>
  );
}

export type LSingleColumnProps = {
  main: React.ReactNode;
  heroLarge?: React.ReactNode;
  heroSmallTop?: React.ReactNode;
  heroSmallBottom?: React.ReactNode;
};
